var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-reward-to-bag-button"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:(_vm.buttonText),expression:"buttonText"}],class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled},on:{"click":_vm.addToBag}})])}
var staticRenderFns = []

export { render, staticRenderFns }